"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThemeManager = void 0;
const react_1 = require("react");
const theme_manager_provider_1 = require("./theme-manager.provider");
const useThemeManager = () => {
    const context = (0, react_1.useContext)(theme_manager_provider_1.ThemeManagerContext);
    if (context) {
        return context;
    }
    throw Error('Erro ao instanciar o contexto do theme manager');
};
exports.useThemeManager = useThemeManager;
